import { render, staticRenderFns } from "./ChangePixKey.vue?vue&type=template&id=49a40c22&scoped=true&"
import script from "./ChangePixKey.vue?vue&type=script&lang=js&"
export * from "./ChangePixKey.vue?vue&type=script&lang=js&"
import style0 from "./ChangePixKey.vue?vue&type=style&index=0&id=49a40c22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a40c22",
  null
  
)

export default component.exports